export const QUERY_KEYS = {
  ptCardInfo: 'ptCardInfo',
  ptCardInfoToCommonProcess: 'ptCardInfoToCommonProcess',
  commonProcessYn: 'commonProcessYn',
};

export const MAIN_DATA_SESSION_KEY = 'ptCardInf';

export const TOOGGLES = {
  QR: 0,
  BARCODE: 1,
};

export const SNUBH_ICON = 'https://storage.googleapis.com/prd-dfd-static-resource/snubh/ptcard-logo.png';
